import React from 'react';
import { Link } from 'react-router-dom';
import SocialLogin from './SocialLogin';

const Register = ({ isDarkMode }) => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start', // 👈 მარცხენა მხარეს
      backgroundColor: isDarkMode ? '#0a0a1a' : '#f5f5f5',
      color: isDarkMode ? '#fff' : '#000',
      padding: '40px'
    }}>
      <Link to="/" style={{
        marginBottom: '30px',
        padding: '8px 16px',
        background: isDarkMode ? '#333' : '#e0e0e0',
        color: isDarkMode ? '#fff' : '#000',
        textDecoration: 'none',
        borderRadius: '6px',
        fontSize: '14px'
      }}>
        ← მთავარი
      </Link>
      
      <h1 style={{ 
        fontSize: '2rem', 
        marginBottom: '5px',
        fontWeight: 'bold'
      }}>
        📝 რეგისტრაცია
      </h1>
      <p style={{ 
        color: isDarkMode ? '#aaa' : '#666', 
        marginBottom: '25px',
        fontSize: '14px'
      }}>
        აირჩიეთ შესვლის მეთოდი
      </p>
      
      <SocialLogin isDarkMode={isDarkMode} />
    </div>
  );
};

export default Register;